export function set_sub_users(state, data) {
    state.sub_users = data;
}
export function set_selected_user(state, userId) {
    state.selected_user = userId;
}
export function set_selected_account(state, accountId) {
    state.selected_account = accountId;
}
export function set_selected_account_info(state, account_info) {
    state.selected_account_info = account_info;
}
export function set_selected_sub_user(state, userId) {
    state.selected_sub_user = userId;
}
export function set_sub_user(state, data) {
    state.sub_users = state.sub_users.map(user => {
        return user.id === data.id ? { ...user, ...data } : user;
    });
}
export function set_credit_consumption_detail(state, consumption_detail) {
    state.credit_consumption_detail = consumption_detail;
}
export function set_right_tab_of_modal(state, tab) {
    state.right_tab_of_modal = tab;
}
export function set_left_tab_of_modal(state, tab) {
    state.left_tab_of_modal = tab;
}
